export default __webpack_public_path__ + "static/media/avantvibes.0215b3a9.jpg";